export const TEMPLATE_LIST_1 = [
  {
    name: "〇〇社製品開発案件",
    description: "一般的な製品開発向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "移動",
        auto_labelings: [],
      },
      {
        name: "会議",
        auto_labelings: [],
      },
      {
        name: "調査",
        auto_labelings: [],
      },
      {
        name: "開発",
        auto_labelings: [],
      },
      {
        name: "保守",
        auto_labelings: [],
      },
      {
        name: "商談",
        auto_labelings: [],
      },
      {
        name: "販売",
        auto_labelings: [],
      },
      {
        name: "販促活動",
        auto_labelings: [],
      },
      {
        name: "事務",
        auto_labelings: [],
      },
      {
        name: "納品",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
    ],
  },
  {
    name: "〇〇社制作案件",
    description: "一般的な制作向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "企画立案",
        auto_labelings: [],
      },
      {
        name: "社内調整",
        auto_labelings: [],
      },
      {
        name: "社外調整",
        auto_labelings: [],
      },
      {
        name: "発注",
        auto_labelings: [],
      },
      {
        name: "デザイン",
        auto_labelings: [],
      },
      {
        name: "搬入",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
    ],
  },
]

export const TEMPLATE_LIST_2 = [
  {
    name: "システムエンジニア",
    description: "一般的なシステムエンジニア向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "会議",
        auto_labelings: [],
      },
      {
        name: "設計",
        auto_labelings: [],
      },
      {
        name: "実装",
        auto_labelings: [],
      },
      {
        name: "レビュー",
        auto_labelings: [],
      },
      {
        name: "テスト",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
    ],
  },
  {
    name: "経理事務",
    description: "一般的な経理業務向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "給与計算",
        auto_labelings: [],
      },
      {
        name: "経費精算",
        auto_labelings: [],
      },
      {
        name: "契約書類作成",
        auto_labelings: [],
      },
      {
        name: "契約書内容確認",
        auto_labelings: [],
      },
      {
        name: "社内コミュニケーション",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
    ],
  },
  {
    name: "採用",
    description: "一般的な採用業務向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "面接",
        auto_labelings: [],
      },
      {
        name: "スカウト",
        auto_labelings: [],
      },
      {
        name: "職務記述書",
        auto_labelings: [],
      },
      {
        name: "採用ページメンテナンス",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
      {
        name: "メール対応",
        auto_labelings: [],
      },
    ],
  },
  {
    name: "労務",
    description: "一般的な労務作業向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "勤怠確認",
        auto_labelings: [],
      },
      {
        name: "保険手続き",
        auto_labelings: [],
      },
      {
        name: "福利厚生業務",
        auto_labelings: [],
      },
      {
        name: "就業規則管理",
        auto_labelings: [],
      },
      {
        name: "安全衛生管理",
        auto_labelings: [],
      },
      {
        name: "労使関係管理",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
    ],
  },
  {
    name: "マーケティング",
    description: "一般的なマーケティング業務向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "セミナー対応",
        auto_labelings: [],
      },
      {
        name: "セミナー企画立案",
        auto_labelings: [],
      },
      {
        name: "市場調査",
        auto_labelings: [],
      },
      {
        name: "メールテンプレ作成",
        auto_labelings: [],
      },
      {
        name: "メール分析",
        auto_labelings: [],
      },
      {
        name: "資料作成",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
      {
        name: "メール対応",
        auto_labelings: [],
      },
    ],
  },
  {
    name: "インサイドセールス",
    description: "一般的なインサイドセールス業務向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "電話対応",
        auto_labelings: [],
      },
      {
        name: "メール対応",
        auto_labelings: [],
      },
      {
        name: "資料作成",
        auto_labelings: [],
      },
      {
        name: "メール分析",
        auto_labelings: [],
      },
      {
        name: "ロールプレイ",
        auto_labelings: [],
      },
      {
        name: "MA調整",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
    ],
  },
  {
    name: "フィールドセールス",
    description: "一般的なフィールドセールス業務向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "電話対応",
        auto_labelings: [],
      },
      {
        name: "メール対応",
        auto_labelings: [],
      },
      {
        name: "商談",
        auto_labelings: [],
      },
      {
        name: "移動時間",
        auto_labelings: [],
      },
      {
        name: "顧客MTG",
        auto_labelings: [],
      },
      {
        name: "提案資料作成",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
    ],
  },
  {
    name: "カスタマーサクセス",
    description: "一般的なカスタマーサクセス業務向けセットです",
    permission: {
      viewable: {
        teams: [],
        members: [],
      },
      usable: {
        teams: [],
        members: [],
      },
    },
    labels: [
      {
        name: "電話対応",
        auto_labelings: [],
      },
      {
        name: "メール対応",
        auto_labelings: [],
      },
      {
        name: "顧客MTG",
        auto_labelings: [],
      },
      {
        name: "資料作成",
        auto_labelings: [],
      },
      {
        name: "企画立案",
        auto_labelings: [],
      },
      {
        name: "オンラインサポート対応",
        auto_labelings: [],
      },
      {
        name: "セミナー対応",
        auto_labelings: [],
      },
      {
        name: "顧客分析",
        auto_labelings: [],
      },
      {
        name: "社内MTG",
        auto_labelings: [],
      },
      {
        name: "社外MTG",
        auto_labelings: [],
      },
    ],
  },
]
